export default {
      id: "resize-gal-usage",
      viewBox: "0 0 49 49",
      url: __webpack_public_path__ + "img/icons.df848786.svg#resize-gal",
      toString: function () {
        return this.url;
      }
    }